import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-modal-close",
  "use": "icon-modal-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-modal-close\"><path d=\"M24 2.462L21.538 0 12 9.537 2.463 0 0 2.462 9.538 12 0 21.537 2.462 24 12 14.462 21.538 24 24 21.538 14.463 12z\" fill=\"#4B4B4B\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol